// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__r_nSA","titleV2":"title_titleV2__RKmDQ","titleLink":"title_titleLink__cQskf"};